import { List, Record } from "immutable";
import { IRJSFSchema } from ".";

export const fromJSON = (json: Partial<IPriceListProcessData>): PriceListProcessRecords => {
  const record: IPriceListProcessRecords = { ...(json as any) };

  return new PriceListProcessRecords(record);
};

export interface IPriceListProcessData {
  list: { [key: string]: IRJSFSchema };
  loading?: boolean;
}

export interface IPriceListProcessRecords {
  list: { [key: string]: IRJSFSchema };
  errors: List<string>;
  loading: boolean;
}

const defaultPriceListProcessProps: IPriceListProcessRecords = {
  list: {},
  loading: false,
  errors: List<string>(),
};

export class PriceListProcessRecords extends Record(defaultPriceListProcessProps) implements IPriceListProcessRecords {}
